import type { SVGProps } from "react";
export interface PenNibIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PenNibIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PenNibIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M9.942 12.385a1.875 1.875 0 0 1-.192 3.74c-.09 0-.178-.01-.264-.022l-6.2 6.2a1.125 1.125 0 1 1-1.59-1.59l6.2-6.2q-.007-.036-.011-.071l-.01-.192.01-.192a1.875 1.875 0 0 1 1.865-1.683zm2.354-7.868A1.126 1.126 0 0 1 13.8 4.44l.085.077 5.596 5.596.078.087a1.124 1.124 0 0 1-1.584 1.582l-.085-.078-5.595-5.596-.078-.085a1.125 1.125 0 0 1 .078-1.506Z"
      />
      <path
        fill={color}
        d="M15.255 1.623a3.35 3.35 0 0 1 4.479.23l2.413 2.414.23.253a3.35 3.35 0 0 1 0 4.226l-.23.254-2.181 2.182a7.77 7.77 0 0 0-2.076 3.744l-.618 2.681a4.46 4.46 0 0 1-3.084 3.274l-.31.08-9.613 2.097c-.869.19-1.7-.046-2.319-.532l-.25-.222a2.78 2.78 0 0 1-.753-2.57l2.096-9.61a4.46 4.46 0 0 1 3.353-3.395l2.682-.62a7.76 7.76 0 0 0 3.745-2.073l2.18-2.183zm2.888 1.82a1.1 1.1 0 0 0-1.38-.14l-.173.14-2.18 2.183a10 10 0 0 1-4.83 2.677L6.9 8.92a2.21 2.21 0 0 0-1.662 1.681L3.14 20.215a.53.53 0 0 0 .147.498l.105.083a.53.53 0 0 0 .394.063l9.611-2.096a2.21 2.21 0 0 0 1.682-1.661l.618-2.682a10 10 0 0 1 2.678-4.83l2.18-2.18.141-.172a1.1 1.1 0 0 0 0-1.209l-.14-.171z"
      />
    </svg>
  );
}
